




































































































































import SelectBranch from "@/components/custom/select/SelectBranch.vue";
import SelectWarehouse from "@/components/custom/select/SelectWarehouse.vue";
import { useDisabledFromTomorrow } from "@/hooks/datepicker";
import { useStockAdjustment } from "@/hooks/useStockAdjustment";
import { Option } from "@/models/class/option.class";
import { MAX_LENGTH_CHARACTER } from "@/models/constant/global.constant";
import { DEFAULT_DATE_FORMAT } from "@/models/constants/date.constant";
import { LogisticStockAdjustmentType } from "@/models/enums/stock-adjustment.enum";
import {
  FormValue,
  StockAdjustmentResponseDTO,
} from "@/models/interface/stock-adjustment";
import { FileCreateResponseDto } from "@/models/interface/storage";
import { FormModel } from "ant-design-vue";
import { Component, Ref, Vue } from "vue-property-decorator";
import { mapGetters, mapMutations } from "vuex";
import FieldAttachment from "./FieldAttachment.vue";
import SelectProductCategory from "./SelectProductCategory.vue";
import { LabelInValue } from "@/types";

const ADJUSTMENT_TYPES_OPTIONS: Array<Option> = [
  {
    label: "lbl_stock_adjustment",
    key: 0,
    value: LogisticStockAdjustmentType.STOCK_ADJUSTMENT,
  },
  {
    label: "lbl_stock_opname",
    key: 1,
    value: LogisticStockAdjustmentType.STOCK_OPNAME,
  },
];

const FORM_PROP = {
  BRANCH: "branch",
  WAREHOUSE: "warehouse",
} as const;

@Component({
  components: {
    SelectProductCategory,
    FieldAttachment,
    SelectBranch,
    SelectWarehouse,
  },
  computed: {
    ...mapGetters({
      form: "stockAdjStore/getForm",
      detail: "stockAdjStore/getDetail",
      isOpname: "stockAdjStore/isOpname",
    }),
  },
  methods: {
    ...mapMutations({
      setForm: "stockAdjStore/setForm",
    }),
  },
})
export default class FormHeader extends Vue {
  DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
  useDisabledFromTomorrow = useDisabledFromTomorrow;

  form!: FormValue;
  isOpname!: boolean;
  detail!: StockAdjustmentResponseDTO;
  setForm!: (payload: Partial<FormValue>) => void;

  @Ref("formModel")
  formModel!: FormModel;

  formRules = {
    branch: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
      },
    ],
    warehouse: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
      },
    ],
    type: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
      },
    ],
    date: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
      },
    ],
    notes: [
      {
        max: MAX_LENGTH_CHARACTER,
        message: this.$t("lbl_x_character_length_exceed_y", {
          x: this.$t("lbl_note"),
          y: MAX_LENGTH_CHARACTER,
        }),
      },
    ],
  };

  typeOptions: Array<Option> = ADJUSTMENT_TYPES_OPTIONS;

  onUploadSuccess(res: FileCreateResponseDto | null): void {
    this.setForm({
      attachment: res?.url || "",
    });
  }

  onChangeType(e?: LogisticStockAdjustmentType): void {
    this.form.type = e || ("" as LogisticStockAdjustmentType);
    this.clearRows();
  }

  clearRows(): void {
    this.setForm({ stockAdjustmentRows: [] });
  }

  clearRowRacks(): void {
    this.setForm({
      stockAdjustmentRows: this.form.stockAdjustmentRows.map(row => ({
        ...row,
        warehouseLocation: undefined,
      })),
    });
  }

  onBranchChange(value?: LabelInValue): void {
    if (value?.key === this.form.branch?.key) return;

    const previousBranch = this.form.branch;

    const apply = () => {
      this.setForm({
        branch: value
          ? { key: String(value.key), label: value.label }
          : undefined,
        warehouse: undefined,
      });
      this.clearRowRacks();
      this.formModel.clearValidate([FORM_PROP.BRANCH, FORM_PROP.WAREHOUSE]);
    };

    const hasRackSelected = this.form.stockAdjustmentRows.some(
      row => !!row.warehouseLocation?.key
    );

    if (!hasRackSelected) {
      apply();
      return;
    }

    this.$confirm({
      title: this.$t("lbl_confirmation"),
      content: this.$t("notif_branch_change_confirm"),
      okText: this.$t("lbl_ok").toString(),
      cancelText: this.$t("lbl_cancel").toString(),
      onOk: apply,
      onCancel: () => {
        this.setForm({ branch: previousBranch });
      },
    });
  }

  onWarehouseChange(value?: LabelInValue): void {
    if (value?.key === this.form.warehouse?.key) return;

    const previousWarehouse = this.form.warehouse;

    const apply = () => {
      this.setForm({
        warehouse: value
          ? { key: String(value.key), label: value.label }
          : undefined,
      });
      this.clearRowRacks();
      this.formModel.clearValidate(FORM_PROP.WAREHOUSE);
    };

    const hasRackSelected = this.form.stockAdjustmentRows.some(
      row => !!row.warehouseLocation?.key
    );

    if (!hasRackSelected) {
      apply();
      return;
    }

    this.$confirm({
      title: this.$t("lbl_confirmation"),
      content: this.$t("notif_warehouse_change_confirm"),
      okText: this.$t("lbl_ok").toString(),
      cancelText: this.$t("lbl_cancel").toString(),
      onOk: apply,
      onCancel: () => {
        this.setForm({ warehouse: previousWarehouse });
      },
    });
  }

  removeAttachment(): void {
    this.setForm({
      attachment: "",
    });
  }

  showAttachment(): void {
    const { viewAttachment } = useStockAdjustment();
    viewAttachment(this.form.attachment);
  }
}
